import React from 'react';
import {MainProps} from './Main.props';
import './Main.styles.css';

const Main: React.FC<MainProps> = () => {
    return (
        <div className='main-page'>
            <h2>Welcome to Webtool page</h2>
        </div>
    );
};

export default Main;